import { cn } from "@newxsystems/shared";
import { AbyssCardLink } from "../AbyssCardLink/AbyssCardLink";
import { AbyssMedia } from "../AbyssMedia/AbyssMedia";
import { AbyssRichText } from "../AbyssRichText/AbyssRichText";
import type { IImageContentGridTopProps } from "./ImageContentGridTop.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridTop = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridTopProps) => (
  <div
    className={cn("grid grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2", columns[columnCount || 3])}
  >
    {items.map((item, index) => (
      <AbyssCardLink
        className="overflow-visible border-0 hover:bg-transparent"
        key={index}
        link={item.cardLink}
      >
        <AbyssMedia
          aspectRatio={imageAspectRatio || "16:9"}
          className="ring-1 ring-inset ring-frost/10"
          imageClassName="transition-transform duration-300 ease-out group-hover:scale-[1.015]"
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
        <div className="border-t border-iron pt-5">
          <h3 className="abyss-type-subhead font-abyss-display font-medium transition-colors group-hover:text-primary">
            {item.heading}
          </h3>
          {item.description ? (
            <AbyssRichText
              className="mt-3 text-base text-fog md:text-lg"
              content={item.description}
            />
          ) : null}
        </div>
      </AbyssCardLink>
    ))}
  </div>
);

ImageContentGridTop.displayName = "Content::ImageContentGridTop";
